"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoShareIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Video share icon for spotlight engagement UI.
 */
function VideoShareIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "16", height: "12", viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.77047 11.5049C8.3174 11.8573 7.65726 11.5344 7.65726 10.9604V8.69355C5.00932 8.69355 2.95726 9.40861 1.58689 10.3238C1.10406 10.6463 0.319374 10.3164 0.370169 9.73801C0.688323 6.11537 2.26069 3.77747 7.65726 3.17785L7.65726 0.910991C7.65726 0.337022 8.3174 0.014158 8.77047 0.366541L14.5308 4.8468C15.2409 5.39909 15.2409 6.47232 14.5308 7.02461L8.77047 11.5049Z", fill: "#fff" }) }));
}
exports.VideoShareIcon = VideoShareIcon;
//# sourceMappingURL=VideoShareIcon.js.map